<script lang="ts">
    import {Component, mixins, toNative} from 'vue-facing-decorator'
    import BookingPageBase from '~src/components/parts/bookingPageBase.src'
    import {ExtraServiceStoreMixin} from '@/mixins/ExtraServiceStoreMixin.vue'

    @Component({mixins: [BookingPageBase]})
    export class ExtraServiceBookingPageLayout extends mixins(ExtraServiceStoreMixin) {
        get productSearchPageName() {
            return 'extraServices'
        }

        get productConfirmationPageName() {
            return 'extraServiceConfirmation'
        }

        get productName() {
            return 'extraService'
        }

        get productBookingPageName() {
            return 'extraServiceBooking'
        }

        get corporatePolicyType() {
            return 'extraService'
        }

        get touristToken() {
            return 'guest'
        }
    }

    export default {...toNative(ExtraServiceBookingPageLayout), ssrRender: BookingPageBase.ssrRender}
</script>
